import React from "react";
const NftImage = () => {
    return (
        <div className="_nft_content_img_wrap">
            <img src="assets/img/nft1.png" alt="Nft" className="_nft_content_img" />
        </div>
    )
}
export default NftImage;
